import React, { FunctionComponent } from 'react';
import { Box, makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
    serverErrorContainer: {
        width: '100%',
        height: '100vh',
        color: '#484848',
        paddingTop: '40px',
        paddingBottom: '150px',
        background: '#FFFFFF',
    },
    errorCode: {
        fontSize: '40px',
        color: '#484848',
        lineHeight: '57px',
        fontWeight: 700,
        marginTop: '10rem',
    },
    serverErrorHeading: {
        fontSize: '36px',
        color: '#484848',
        lineHeight: '43px',
        fontWeight: 500,
        marginTop: '10px',
    },
    serverErrorMessage1: {
        fontSize: '18px',
        color: '#484848',
        lineHeight: '31.92px',
        marginTop: '40px',
    },
});

type PageNotFoundProps = {};

const PageNotFound: FunctionComponent<PageNotFoundProps> = () => {
    const classes = useStyles();
    return (
        <Box className={classes.serverErrorContainer} display="d-flex" flexDirection="column">
            <Box className={classes.errorCode} display="flex" justifyContent="center">
                404
            </Box>
            <Box className={classes.serverErrorHeading} display="flex" justifyContent="center">
                Page Not Found
            </Box>
            <Box className={classes.serverErrorMessage1} display="flex" justifyContent="center">
                Sorry, we could not find your desired page.
            </Box>
        </Box>
    );
};

export default PageNotFound;
